export default {
  title: '傳送代幣', close: '關閉傳送視窗', currentAccount: '目前發送帳戶：{{source}}',
  browserOnlyMetaMask: '網頁版只能使用 MetaMask 發送。你目前選擇的是 World App 帳戶，請返回 World App 使用 World App 地址發送。',
  sendInWorldApp: '在 World App 中發送', worldAppLinkMissing: 'World App 連結尚未設定。', browserMetaMaskOnly: '網頁版發送只會由 MetaMask 簽署，請先連接 MetaMask。',
  noBalances: '目前沒有可用的鏈上餘額資料，請先更新餘額。', usingMetaMask: '目前使用 MetaMask 簽署 World Chain 發送。', token: '代幣',
  availableBalance: '可用餘額', max: '全部', recipient: '收款地址', amount: '數量', viewTransaction: '查看交易：{{hash}}', submit: '傳送代幣',
  transactionTitle: '傳送代幣中…', transactionDescription: '正在透過 World App 向收款地址發送 {{amount}} {{symbol}}。',
  confirmed: '交易已確認，鏈上餘額將會更新。',
} as const;
